// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
import store from "../store/index"
import clipboard from 'clipboard';
Vue.use(ElementUI);

import {
  message
} from '@/utils/resetMessage'
Vue.prototype.$message = message;

Vue.prototype.clipboard = clipboard
Vue.prototype.testPhone = function(phone) {
	var pattern = /^1[3456789]\d{9}$/;
	if (pattern.test(phone)) {
		return true;
	} else {
		return false;
	}
}
Vue.prototype.couponStatus = {
	setCoupon(majorIdKey, status) {
		console.log(majorIdKey);
		console.log(status);
		localStorage.setItem(majorIdKey, status)
	},
	getCoupon(majorIdKey) {
		return localStorage.getItem(majorIdKey)
	},
}
Vue.prototype.getEncryptPhone = function(phone) {
	var pattern = /^1[3456789]\d{9}$/;
	if (pattern.test(phone)) {
		var encryptPhone = phone.substr(0, 3) + '****' + phone.substr(7)
		return encryptPhone;
	}
	return phone;
}
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	store,
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js